import {useEffect} from "react";
import {IMPORT_FORM} from "v4/data/apiRoutes";
import useFetch from "v4/hooks/useFetch";
import {generateUrl} from "v4/services/api.service";
import {useForm} from "react-hook-form";
import {useImportContext} from "v4/pages/admin/Import/contexts/ImportContext";
import {appendFileField, isFileDTOList} from "v4/DTO/FileDTO";

export default function useCreateImportForm() {
    const {nextStep, updateSelectedEntityType} = useImportContext();
    const [{data, isLoading}, fetchImportForm] = useFetch();
    const [{data: submitData, isLoading: isSubmitLoading}, submitImportForm] = useFetch();
    const importFormInputs = data?.['hydra:member'];

    const methods = useForm();

    const onSubmit = (data) => {
        submitImportForm({
            url: generateUrl(IMPORT_FORM),
            config: {
                method: 'POST',
                body: jsonToFormData(data),
            }
        });
    }

    useEffect(() => {
        if (submitData?.import.state !== 'mapping') return;
        
        nextStep(submitData.import.id);
    }, [nextStep, submitData]);

    useEffect(() => {
        fetchImportForm({
            url: generateUrl(IMPORT_FORM),
        });
    }, [fetchImportForm]);

    useEffect(() => {
        const subscription = methods.watch((value, { name }) => {
            if (name !== 'entityType') return;

            updateSelectedEntityType(value.entityType);
        });

        return () => subscription.unsubscribe();
        // eslint-disable-next-line
    }, [methods.watch, updateSelectedEntityType]);

    return {
        isFormLoading: isLoading,
        importFormInputs,
        formMethods: methods,
        onSubmit,
        isSubmitLoading,
    }
}

function jsonToFormData(data) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (isFileDTOList(value)) {
            appendFileField(formData, key, value);
            return;
        }

        formData.append(key, value);
    });

    return formData;
}
